<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2022-10-25 09:45:23
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-07-12 17:40:54
 * @FilePath: /wemeet-admin-new/src/views/dragger/template/tpl_holdMeet.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<!--
* @description:
* @fileName tpl_page.vue
* @author hvv
* @date 2022/02/15 16:15:54
!-->
<template>
  <div class="shopItem">
    <img alt="" class="imgBox" :src="res.coverUrl" />
    <div class="contentBox">
      <div class="name">{{ res.meetingName || res.name }}</div>
    </div>
  </div>
</template>

<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, toRefs, watch, computed } from 'vue'
  export default defineComponent({
    name: 'tpl_page.vue',
    props: {
      res: {
        type: Object,
      },
    },
    setup(props) {
      const state = reactive({
        url: props.res.meetingBannerDtos[0].fileUrl,
      })
      watch(
        () => props.res,
        (nval, oval) => {
          console.log(nval, '111vvv')
          if (nval.meetingBannerDtos && nval.meetingBannerDtos.length > 0) {
            let item = nval.meetingBannerDtos.filter((v) => v.type == 1)
            if (item.length > 0) {
              state.url = item[0].fileUrl
            }
          }
        }
      )

      return {
        ...toRefs(state),
      }
    },
  })
</script>
<style lang="scss" scoped>
  .shopItem {
    .imgBox {
      width: 100%;
      height: 160px;
      object-fit: cover;
    }
    .contentBox {
      box-sizing: border-box;
      width: 100%;
      height: 60px;
      padding: 10px;
    }
  }
</style>
